export var formatGradeSkill = function (gradeShortName, skillName) { return gradeShortName + " | " + skillName; };
